import { biography, publications } from '../../content/siteContent';
import { AnimatedSection } from '../components/AnimatedSection';
import { BookCover } from '../components/BookCover';
import { BookingCta } from '../components/BookingCta';

export function BooksMediaPage() {
  return (
    <>
      <header className="page-hero books-hero">
        <p className="eyebrow">Published work · Television · Press</p>
        <h1>Books & Media</h1>
        <p className="page-hero__lead">Ancient practices translated into clear, visual frameworks for modern life.</p>
      </header>
      <AnimatedSection className="publication-list" aria-label="Publications">
        {publications.map((publication, index) => (
          <article className="publication" key={publication.title}>
            <BookCover
              publication={publication}
              containerClassName="publication__cover-frame"
              imageClassName="publication__cover"
            />
            <div>
              <p className="eyebrow">{publication.status === 'published' ? 'Award-winning book' : 'Forthcoming'}</p>
              <h2>{publication.title}</h2>
              <p>{index === 0 ? 'A visual introduction to the healing power of movement and breath that has helped thousands begin a Qigong practice.' : 'A practical integration of Qigong and fitness for strength, adaptability, and a longer life in motion.'}</p>
              {publication.purchaseUrl && (
                <a
                  className="text-link publication__amazon-link"
                  href={publication.purchaseUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  View on Amazon
                </a>
              )}
            </div>
          </article>
        ))}
      </AnimatedSection>
      <AnimatedSection className="media-section">
        <div><p className="eyebrow">On screen</p><h2>Qigong for the wider community.</h2></div>
        <p>{biography[2]} Christina produced and hosted three seasons of Qigong programming for Atlanta Interfaith Broadcasting, including a Spanish-language season.</p>
      </AnimatedSection>
      <BookingCta />
    </>
  );
}
